import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { listNumbers } from '@teqplay/viewer'
export default class BollardAxisLabels extends PureComponent {
  static propTypes = {
    quays: PropTypes.array,
    bollardToScreen: PropTypes.func.isRequired
  }

  render() {
    const quaysToRender =
      this.props.quays &&
      this.props.quays.filter(quay => typeof quay.minBollard === 'number' && typeof quay.maxBollard === 'number')

    if (quaysToRender) {
      const bollards = listNumbers(quaysToRender[0].minBollard, quaysToRender[quaysToRender.length - 1].maxBollard)

      return (
        <div className="bollard-numbers">
          {bollards.map((bollard, index) => {
            const left = this.props.bollardToScreen(bollard)
            const quayStart = quaysToRender.find(quay => quay.minBollard === bollard)
            const quayEnd = quaysToRender.find(quay => quay.maxBollard === bollard)
            const terminalEnd = quaysToRender[quaysToRender.length - 1].maxBollard === bollard
            let currentQuay = quaysToRender.find(quay => bollard >= quay.minBollard && bollard + 1 <= quay.maxBollard)

            if (terminalEnd) {
              currentQuay = quaysToRender.find(quay => bollard - 1 >= quay.minBollard && bollard <= quay.maxBollard)
            }

            if (
              (currentQuay && currentQuay.quayType && currentQuay.quayType === 'BOLLARD') ||
              quayStart ||
              terminalEnd
            ) {
              return (
                <div
                  key={index}
                  style={{ left }}
                  className={`bollard-axis-grid ${quayStart || terminalEnd ? 'quay-border' : ''}`}
                >
                  {(currentQuay && currentQuay.quayType && currentQuay.quayType === 'BOLLARD') ||
                  (quayEnd && currentQuay && currentQuay.quayType && quayEnd.quayType === 'BOLLARD') ? (
                    <div className="label">{bollard}</div>
                  ) : null}
                </div>
              )
            }

            return null
          })}
        </div>
      )
    }
    return null
  }
}
